import { render } from "./HelloWorld.vue?vue&type=template&id=25d525f8&scoped=true&bindings={\"msg\":\"props\"}"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=25d525f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25d525f8"

export default script